export type NativeAnswerAcceptOptions = {
  bypassRecordingConsent: true
  skipPermissionPreflight?: true
}

/**
 * Accept options for an answer taken on the OS call UI (iOS CallKit; Android
 * Telecom from the car, Bluetooth, lock screen or notification). Answering
 * there connects audio immediately, whether the app was already open or
 * cold-started: the in-app consent modal may be on a screen nobody can see,
 * so it must never gate media. The answer carries the NO_NOTICE_UI skip
 * reason (never a consent), and the consent prompt follows as the
 * non-blocking post-connect sheet inside the 30-second window.
 *
 * iOS also skips the permission pre-flight, which can hang or misreport in a
 * backgrounded WebView; Android foregrounds the app, so it keeps it.
 */
export function nativeAnswerAcceptOptions(
  platform: 'ios' | 'android' | 'web' | string | null | undefined,
): NativeAnswerAcceptOptions | undefined {
  if (platform === 'ios') return { bypassRecordingConsent: true, skipPermissionPreflight: true }
  if (platform === 'android') return { bypassRecordingConsent: true }
  return undefined
}
